import React from 'react';
import { Modal } from 'react-bootstrap';
import FileViewer from "../FileViewer";

const FileModal = ({ onHide, fileUrl }) => {
    return (
        <Modal show={true} onHide={onHide} bsSize="lg">
            <Modal.Body>
                <FileViewer src={fileUrl} name={"Archivo"} />
            </Modal.Body>
            <Modal.Footer>
                <button type="button" onClick={onHide} className="btn btn-danger pull-left">
                    Cerrar
                </button>
                <a href={fileUrl} target="_blank" rel="noopener">
                    <button className="btn btn-success">
                        Descargar
                    </button>
                </a>
            </Modal.Footer>
        </Modal>
    );
};

export default FileModal;



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/FileViewerModal/index.js